import { Box, createStyles } from '@mantine/core';
import { Text } from '@repo/foundations';

const useStyles = createStyles((theme) => ({
	container: {
		margin: `0 ${theme.spacing['2xs']}`,
		width: `calc(100% - (2 * ${theme.spacing['2xs']}))`,
		padding: `${theme.spacing['2xs']}`,
	},
}));

export function SelectorItemEmpty({ children }: { children: React.ReactNode }) {
	const { classes } = useStyles();

	return (
		<Box className={classes.container}>
			<Text size="sm" color="text/primary/default">
				{children}
			</Text>
		</Box>
	);
}
